import { FC, useEffect, useState } from "react";
import { getCurrentWindow } from "@tauri-apps/api/window";

export const CustomTitlebar: FC = () => {
  const win = getCurrentWindow();
  const [isMaximized, setIsMaximized] = useState(false);

  // Check initial maximize state
  useEffect(() => {
    const checkMaximized = async () => {
      try {
        const isMax = await win.isMaximized();
        setIsMaximized(isMax);
      } catch (error) {
        console.error("Failed to check maximize state:", error);
      }
    };
    checkMaximized();
  }, [win]);

  const handleMinimize = async () => {
    try {
      await win.minimize();
    } catch (error) {
      console.error("Failed to minimize window:", error);
    }
  };

  const handleMaximize = async () => {
    try {
      console.log("Current maximize state:", isMaximized);

      if (isMaximized) {
        console.log("Unmaximizing window...");
        await win.unmaximize();
        setIsMaximized(false);
      } else {
        console.log("Maximizing window...");
        await win.maximize();
        setIsMaximized(true);
      }
    } catch (error) {
      console.error("Failed to toggle maximize:", error);
    }
  };

  const handleClose = async () => {
    try {
      await win.close();
    } catch (error) {
      console.error("Failed to close window:", error);
    }
  };

  return (
    <div
      className="custom-titlebar relative flex items-center justify-between px-2 bg-slate-900/90 border-b border-slate-800 select-none"
      data-tauri-drag-region
    >
      {/* Centered Title */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        data-tauri-drag-region
      >
        <span className="text-[11px] tracking-wide text-slate-300">
          TracQ | Your Data - Simplified
        </span>
      </div>

      {/* Left spacer (keeps drag region) */}
      <div className="flex items-center gap-2 opacity-70" data-tauri-drag-region>
        {/* Removed branding dot */}
      </div>

      {/* Window Controls */}
      <div className="flex items-center gap-1">
        <button
          aria-label="Minimize"
          className="w-8 h-8 grid place-items-center rounded-md hover:bg-slate-800/70 text-slate-300 transition-colors"
          onClick={handleMinimize}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" className="opacity-80">
            <rect x="2" y="6" width="8" height="1" fill="currentColor" />
          </svg>
        </button>
        <button
          aria-label={isMaximized ? "Restore" : "Maximize"}
          className="w-8 h-8 grid place-items-center rounded-md hover:bg-slate-800/70 text-slate-300 transition-colors"
          onClick={handleMaximize}
        >
          {isMaximized ? (
            // Restore icon (two overlapping squares)
            <svg width="12" height="12" viewBox="0 0 12 12" className="opacity-80">
              <rect
                x="2"
                y="2"
                width="6"
                height="6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
              />
              <rect
                x="4"
                y="4"
                width="6"
                height="6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
              />
            </svg>
          ) : (
            // Maximize icon (single square)
            <svg width="12" height="12" viewBox="0 0 12 12" className="opacity-80">
              <rect
                x="2.5"
                y="2.5"
                width="7"
                height="7"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
              />
            </svg>
          )}
        </button>
        <button
          aria-label="Close"
          className="w-8 h-8 grid place-items-center rounded-md hover:bg-red-900/40 text-slate-300 transition-colors"
          onClick={handleClose}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" className="opacity-80">
            <path d="M3 3l6 6M9 3L3 9" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CustomTitlebar;
